var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg028Experiment = function Svg028Experiment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 121V61h30V31H60v30h30v60zM422 121V61h30V31H271v30h30v60zM422 151H301v60h-90v-60H90v60H0v30h30v180H0v60h512v-60h-30V241h30v-30h-90zM60 241h30v60c0 33.091 27.909 60 61 60s60-26.909 60-60v-60h30v180H60zm392 0v180H271V241h30v60c0 33.091 26.909 60 60 60s61-26.909 61-60v-60z"
  })));
};
export default Svg028Experiment;